import './App.css';
import Controls from './components/controls/Controls';
import Navbar from './components/navbar/Navbar';
import NavbarLinks from './components/navbarLinks/NavbarLinks';
import Section1 from './components/section1/Section1';
import Section2 from './components/section2/Section2';
import Section3 from './components/section3/Section3';
import Section4 from './components/section4/Section4';
import Section5 from './components/section5/Section5';
import Section6 from './components/section6/Section6';

function App() {
  return (
    <>
      <div className={`container`}>
        <Navbar />
        <NavbarLinks />
        <Controls />
        <section>
          <Section1 />
        </section>
        <section>
          <Section2 />
        </section>
        <section>
          <Section3 />
        </section>
        <section>
          <Section4 />
        </section>
        <section>
          <Section5 />
        </section>
        <section>
          <Section6 />
        </section>
      </div>
    </>
  );
}

export default App;
